module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "booking"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.schedules.booking_number_per_time_slot')))]), _vm._v(" "), _c('multiselect', {
    staticClass: "booking-options",
    attrs: {
      "id": "booking",
      "selected-label": "",
      "select-label": "",
      "deselect-label": "",
      "placeholder": "",
      "options": _vm.numberOptions,
      "allow-empty": false
    },
    model: {
      value: (_vm.booking),
      callback: function($$v) {
        _vm.booking = $$v
      },
      expression: "booking"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "bookingHelpInline"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.schedules.booking_number_per_time_slot_e_g')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-divider"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dd8c1c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkingBookingPerSlot.vue
// module id = 984
// module chunks = 1